<template>
  <b-modal id="modal-request-approval" size="xl" ref="modal" @show="setData" title="Travel Request Approval" :hide-footer="hideButton">
    <form id="form" action="#" autocomplete="off">
      <!-- grid row -->
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <legend>Travel Data</legend>
              <div class="form-row">
                <label class="col-md-3">Employee</label>
                <div class="col-md-6 mb-3">
                  {{detail.emp_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Transaction Number</label>
                <div class="col-md-6 mb-3">
                  {{detail.number}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Request Date</label>
                <div class="col-md-6 mb-3">
                  {{formatDate(detail.date, 2)}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Travel Partner</label>
                <div class="col-md-6 mb-3">
                  {{detail.partner}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Travel Purpose</label>
                <div class="col-md-6 mb-3">
                  {{detail.purpose_name}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Travel Activities or Summary</label>
                <div class="col-md-6 mb-3">
                  {{detail.activities == null ? detail.activity : detail.activities}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Activity Days</label>
                <div class="col-md-5 mb-3">
                  {{detail.activity_start}} - {{detail.activity_end}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Payment Method</label>
                <div class="col-md-5 mb-3">
                  {{detail.paymethod_name}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Total Travel Expense</label>
                <div class="col-md-5 mb-3">
                  {{detail.curr_code}}
                  {{numberWithCommas(detail.travel_expense_amount)}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-5 mb-3">
                  {{detail.travel_stat_name}}
                </div>
              </div>
              <hr>
              <legend>Itenary</legend>

              <div class="form-group">
                <label class="control-label">Ticket / Car Order</label>
                <div class="table-responsive">
                  <table class="table table-hover table-striped" aria-label="Ticket">
                    <thead>
                    <tr>
                      <th style="width:50px" id="no">#</th>
                      <th style="width:150px" id="date">Date</th>
                      <th style="width:150px" id="transport-with">Transport With</th>
                      <th style="width:150px" id="from">From</th>
                      <th style="width:150px" id="to">To</th>
                      <th style="width:150px" id="departure">Departure</th>
                      <th style="width:150px" id="arrival">Arrival</th>
                      <th style="width:150px" id="paid-by">Paid By</th>
                      <th style="width:150px" id="amount">Amount</th>
                    </tr>
                    </thead>
                    <tbody id="tickets-body">
                    <tr v-for="(ticket, i) in tickets" v-bind:key="i">
                      <td></td>
                      <td>{{formatDate(ticket.date, 2)}}</td>
                      <td>{{ticket.carrier}}</td>
                      <td>{{ticket.depart}}</td>
                      <td>{{ticket.arrive}}</td>
                      <td>{{ (ticket.etd !== null  ? ticket.etd.substring(0, 5) : "-")}}</td>
                      <td>{{ (ticket.eta !== null  ? ticket.eta.substring(0, 5) : "-")}}</td>
                      <td>{{ticket.paid_by=="admin"? 'Admin':'Personal'}}</td>
                      <td>{{numberWithCommas(ticket.amount)}}</td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                      <th id="total" colspan="8" class="text-center">Total</th>
                      <td>
                        {{numberWithCommas(total_ticket)}}
                      </td>
                    </tr>
                    </tfoot>
                  </table>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label">Hotel Order</label>
                <div class="table-responsive">
                  <table class="table table-hover table-striped" aria-label="Hotel">
                    <thead>
                    <tr>
                      <th style="width:50px" id="no-hotel">#</th>
                      <th style="width:201px;" id="check-in">Check-in</th>
                      <th style="width:201px;" id="check-out">Check-out</th>
                      <th style="width:201px;" id="accommodation">Accommodation</th>
                      <th style="width:201px;" id="remark">Remark</th>
                      <th style="width:201px;" id="paid-by-hotel">Paid By</th>
                      <th style="width:201px;" id="amount-hotel">Amount</th>
                    </tr>
                    </thead>
                    <tbody >
                    <tr v-for="(hotel, i) in hotels">
                      <td></td>
                      <td>{{formatDate(hotel.check_in,2)}}</td>
                      <td>{{formatDate(hotel.check_out, 2)}}</td>
                      <td>{{hotel.accommodation}}</td>
                      <td>{{hotel.remarks}}</td>
                      <td>{{hotel.paid_by=="admin"? 'Admin':'Personal'}}</td>
                      <td>{{numberWithCommas(hotel.amount)}}</td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                      <th id="total_hotel" colspan="6" class="text-center">Total</th>
                      <td>
                        {{numberWithCommas(total_hotel)}}
                      </td>
                    </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Travel cost paid by Admin</label>
                <div class="col-md-3 mb-3">
                  {{numberWithCommas(paid_admin_amount)}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Cash Advance Amount</label>
                <div class="col-md-3 mb-3">
                  {{numberWithCommas(cash_advance_amount)}}
                </div>
              </div>

              <hr>
              <legend>Approval</legend>
              <template v-if="detail.travel_stat_id !== 0">
                <div class="form-group">
                  <label class="control-label">Approval Information</label>
                  <div class="table-responsive">
                    <table class="table table-hover table-striped" aria-label="Approval Information">
                      <thead>
                      <tr>
                        <th style="min-width:10px" id="level"> Level </th>
                        <th id="name"> Name </th>
                        <th id="email"> Email </th>
                        <th id="status"> Status </th>
                        <th id="date_approval"> Date </th>
                      </tr>
                      </thead>
                      <tbody >
                      <tr v-for="(data, i) in list_supervisor">
                        <td>{{data.level}}</td>
                        <td>{{data.name}}</td>
                        <td>{{data.email}}</td>
                        <td>{{data.status_name}}</td>
                        <td>{{data.status_date}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </template>
              <list-supervisor :emp_id="detail.emp_id.toString()" v-else></list-supervisor>
            </div><!-- /.card-body -->
          </div><!-- /.card -->
        </div><!-- /grid column -->
      </div><!-- /grid row -->
    </form>
    <template v-slot:modal-footer >
      <div class="w-100">
        <button class="btn btn-success float-right mr-1" @click="stat_id=3;handleOk($event)"> Approve </button>
        <button class="btn btn-danger float-right mr-1" @click="stat_id=5; handleOk($event)"> Reject </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BModal} from "bootstrap-vue";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import ListSupervisor from "../employee/ListSupervisor";
import formatDate from '../../../../libs/FormatDate'

export default {
  name: "TravelRequestApproval",
  components:{
    ListSupervisor,
    BModal
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      stat_id:1,
      detail:{},
      tickets:[],
      hotels:[],
      paid_admin_amount:0,
      cash_advance_amount:0,
      total_ticket:0,
      total_hotel:0,
      hideButton:false,
      list_supervisor:[],
      arr_action:['rejected', 'approved', 'cancelled']
    }
  },
  methods:{
    handleOk(){
      let payload = {
        stat_id:this.stat_id,
        emp_id:this.$store.getters.empId,
        trans_id:this.data.trans_id,
        master_id:this.data.master_id,
        log_id:this.data.id
      }

      AxiosCall.Post(payload, urlApi.travel_request.approval).then(res=>{
        if(res.success){
          this.$root.$children[0].successMessage(res.message)
          this.$refs.modal.hide()
          this.$parent.getData()
        }else{
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    getDetail(){
      let payload = {id:this.data.master_id}
      AxiosCall.Get(payload, urlApi.travel_request.detail).then(res=>{
        if(res.success){
          this.detail = res.atributes
          this.tickets = (res.atributes.tickets !== null) ? JSON.parse(res.atributes.tickets) : []
          this.hotels =  (res.atributes.hotels !== null ) ? JSON.parse(res.atributes.hotels) : []
          this.calcHotel()
          this.calcTicket()
          this.checkStatus()
          if(this.detail.travel_stat_id !== 0) this.getListSupervisor()
        }else{
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    setData(){
      setTimeout(()=>{
        if(this.data !== null){
          this.getDetail()
        }
      }, 100)
    },
    calcHotel(){
      this.total_hotel = 0
      this.total_hotel_by_admin = 0
      for (let data of this.hotels){
        if (data.amount !== "") {
          this.total_hotel += parseInt(data.amount)
          if (data.paid_by !== undefined){
            if (data.paid_by === "admin") {
              this.total_hotel_by_admin += parseInt(data.amount)
            }
          }
        }
      }
      this.calcTotal()
    },
    calcTicket(){
      this.total_ticket = 0
      this.total_ticket_by_admin = 0
      for (let data of this.tickets){
        if (data.amount !== ""){
          this.total_ticket += parseInt(data.amount)
          if (data.paid_by !== undefined){
            if (data.paid_by === "admin" ) {
              this.total_ticket_by_admin += parseInt(data.amount)
            }
          }
        }
      }
      this.calcTotal()
    },
    calcTotal(){
      let paid_admin_amount = parseInt(this.total_hotel_by_admin) + parseInt(this.total_ticket_by_admin)
      this.paid_admin_amount = paid_admin_amount
      this.cash_advance_amount = parseInt(this.detail.travel_expense_amount) - this.paid_admin_amount
      this.cash_advance_amount = (this.cash_advance_amount < 0) ? 0 : this.cash_advance_amount
    },
    checkStatus(){
      this.hideButton =  ((this.detail.emp_id == this.$store.getters.empId) && this.arr_action.includes(this.data.action)) ? true :false
    },
    getListSupervisor(){
      let payload = {
        id:this.detail.id
      }
      AxiosCall.Get(payload, urlApi.travel_request.status).then(res=>{
        if(res.success){
          this.list_supervisor = res.atributes
          for(let dt of this.list_supervisor){
            if(dt.emp_id == this.$store.getters.empId && dt.status_name !== null ) {
              this.hideButton = true
              break
            }
          }
        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    numberWithCommas(x) {
      if(x !== undefined) return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+".00";
    },
    formatDate(val, type){
      return formatDate(val, type)
    }
  }
}
</script>